import reducerRegistry from '@comeon/reducer-registry';
import { createSlice } from '@reduxjs/toolkit';

import { RootState } from '~/store/types';
import createSliceSelector from '~/utils/create-slice-selector';

const REDUCER_NAME = 'footer';

type State = {
	enableFooterBonusTab: boolean;
	sponsorIcons: boolean;
	hideSportsEGRLogoFooter: boolean;
	showInfoAffiliatePage: boolean;
	enableFAQLinkInFooter: boolean;
	hideCasinoEGRLogoFooter: boolean;
	affiliateFooterTab: boolean;
	footerLinks: string;
	hideSocialMediaLinks: boolean;
	hideWeSpinEGRLogoFooter: boolean;
	LicenseLogoSweden: boolean;
	showLinkToExternalCookiePolicyOnFooter: boolean;
};

const initialState: State = {
	enableFooterBonusTab: false,
	sponsorIcons: false,
	hideSportsEGRLogoFooter: false,
	showInfoAffiliatePage: false,
	enableFAQLinkInFooter: false,
	hideCasinoEGRLogoFooter: false,
	affiliateFooterTab: false,
	footerLinks: '',
	hideSocialMediaLinks: false,
	hideWeSpinEGRLogoFooter: false,
	LicenseLogoSweden: false,
	showLinkToExternalCookiePolicyOnFooter: false
};

// Use Redux Toolkit APIs
const footerSlice = createSlice({
	name: REDUCER_NAME,
	initialState,
	reducers: {} // Leave empty for now as this slice is just a store
});

const footerStateSelector = createSliceSelector<State>(REDUCER_NAME);
export const selectFooterState = (state: RootState) => footerStateSelector(state);

export const selectEnableFooterBonusTab = (state: RootState) => selectFooterState(state).enableFooterBonusTab;
export const selectSponsorIcons = (state: RootState) => selectFooterState(state).sponsorIcons;
export const selectHideSportsEGRLogoFooter = (state: RootState) => selectFooterState(state).hideSportsEGRLogoFooter;
export const selectHideWeSpinEGRLogoFooter = (state: RootState) => selectFooterState(state).hideWeSpinEGRLogoFooter;
export const selectHideCasinoEGRLogoFooter = (state: RootState) => selectFooterState(state).hideCasinoEGRLogoFooter;
export const selectShowInfoAffiliatePage = (state: RootState) => selectFooterState(state).showInfoAffiliatePage;
export const selectEnableFAQLinkInFooter = (state: RootState) => selectFooterState(state).enableFAQLinkInFooter;
export const selectAffiliateFooterTab = (state: RootState) => selectFooterState(state).affiliateFooterTab;
export const selectFooterLinks = (state: RootState) => selectFooterState(state).footerLinks;
export const selectHideSocialMediaLinks = (state: RootState) => selectFooterState(state).hideSocialMediaLinks;
export const selectLicenseLogoSweden = (state: RootState) => selectFooterState(state).LicenseLogoSweden;
export const selectShowLinkToExternalCookiePolicyPage = (state: RootState) =>
	selectFooterState(state).showLinkToExternalCookiePolicyOnFooter;

reducerRegistry.register(REDUCER_NAME, footerSlice.reducer);

export default footerSlice.reducer;
